import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import attendanceAPI from '@/app/services/attendanceAPI';
import hodDashboardAPI from '@/app/services/hodDashboardAPI';
import attendancePunchAPI from '@/app/services/attendancePunchAPI';
import studentAttendanceAPI from '@/app/services/studentAttendanceAPI';
import studentDashboardAPI from '@/app/services/studentDashboardAPI';
import studentHolidayAPI from '@/app/services/studentHolidayAPI';
import studentWeekOffAPI from '@/app/services/studentWeekOffAPI';

import {
  profileAPI,
  contactUpdateAPI,
  CommonAPI,
  menuAPI,
  NotificationAPI
} from "@gyandiksha/shared-ui/app/services";

const appReducer = (state = {}) => state;

export const store = configureStore({
  reducer: {
    app: appReducer,
    [profileAPI.reducerPath]: profileAPI.reducer,
    [contactUpdateAPI.reducerPath]: contactUpdateAPI.reducer,
    [CommonAPI.reducerPath]: CommonAPI.reducer,
    [hodDashboardAPI.reducerPath]: hodDashboardAPI.reducer,
    [studentAttendanceAPI.reducerPath]: studentAttendanceAPI.reducer,
    [studentDashboardAPI.reducerPath]: studentDashboardAPI.reducer,
    [attendanceAPI.reducerPath]: attendanceAPI.reducer,
    [attendancePunchAPI.reducerPath]: attendancePunchAPI.reducer,
    [studentHolidayAPI.reducerPath]: studentHolidayAPI.reducer,
    [studentWeekOffAPI.reducerPath]: studentWeekOffAPI.reducer,
    [menuAPI.reducerPath]: menuAPI.reducer,
    [NotificationAPI.reducerPath]: NotificationAPI.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      profileAPI.middleware,
      contactUpdateAPI.middleware,
      CommonAPI.middleware,
      hodDashboardAPI.middleware,
      studentAttendanceAPI.middleware,
      studentDashboardAPI.middleware,
      attendanceAPI.middleware,
      attendancePunchAPI.middleware,
      studentHolidayAPI.middleware,
      studentWeekOffAPI.middleware,
      menuAPI.middleware,
      NotificationAPI.middleware,
    ),
});

setupListeners(store.dispatch);
